module.exports = __webpack_public_path__ + "static/img/tu6@2x.e678f429.png";